import React, { useState } from "react";

export default function SubjectsTable() {
  // Initial mock data for subjects
  const [subjects, setSubjects] = useState([
    { id: 1, code: "MATH11", name: "General Mathematics", gradeLevel: "Grade 11", strand: "STEM", teacher: "Mr. Cruz", schedule: "Mon/Wed 8:00-9:00", room: "201" },
    { id: 2, code: "ENG12", name: "English for Academic Purposes", gradeLevel: "Grade 12", strand: "ABM", teacher: "Ms. Santos", schedule: "Tue/Thu 10:00-11:00", room: "202" },
    { id: 3, code: "SCI10", name: "Science", gradeLevel: "Grade 10", strand: "", teacher: "Mr. Reyes", schedule: "Fri 1:00-2:00", room: "203" },
  ]);

  // State for new subject form
  const [newSubject, setNewSubject] = useState({ code: "", name: "", gradeLevel: "", strand: "", teacher: "", schedule: "", room: "" });

  // Add new subject
  const handleAddSubject = (e) => {
    e.preventDefault();
    if (!newSubject.code.trim() || !newSubject.name.trim()) return;
    setSubjects([
      ...subjects,
      { id: Date.now(), ...newSubject },
    ]);
    setNewSubject({ code: "", name: "", gradeLevel: "", strand: "", teacher: "", schedule: "", room: "" });
  };

  // Edit subject
  const handleEditSubject = (id, updatedSubject) => {
    setSubjects(subjects.map(s => (s.id === id ? { ...s, ...updatedSubject } : s)));
  };

  // Delete subject
  const handleDeleteSubject = (id) => {
    setSubjects(subjects.filter(s => s.id !== id));
  };

  // Inline edit state
  const [editId, setEditId] = useState(null);
  const [editSubject, setEditSubject] = useState({ code: "", name: "", gradeLevel: "", strand: "", teacher: "", schedule: "", room: "" });

  return (
    <div>
      <form className="mb-4" onSubmit={handleAddSubject} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input className="form-control" style={{ maxWidth: 100 }} type="text" placeholder="Code" value={newSubject.code} onChange={e => setNewSubject({ ...newSubject, code: e.target.value })} required />
        <input className="form-control" style={{ maxWidth: 180 }} type="text" placeholder="Name" value={newSubject.name} onChange={e => setNewSubject({ ...newSubject, name: e.target.value })} required />
        <input className="form-control" style={{ maxWidth: 120 }} type="text" placeholder="Grade Level" value={newSubject.gradeLevel} onChange={e => setNewSubject({ ...newSubject, gradeLevel: e.target.value })} />
        <input className="form-control" style={{ maxWidth: 120 }} type="text" placeholder="Strand" value={newSubject.strand} onChange={e => setNewSubject({ ...newSubject, strand: e.target.value })} />
        <input className="form-control" style={{ maxWidth: 120 }} type="text" placeholder="Teacher" value={newSubject.teacher} onChange={e => setNewSubject({ ...newSubject, teacher: e.target.value })} />
        <input className="form-control" style={{ maxWidth: 160 }} type="text" placeholder="Schedule" value={newSubject.schedule} onChange={e => setNewSubject({ ...newSubject, schedule: e.target.value })} />
        <input className="form-control" style={{ maxWidth: 80 }} type="text" placeholder="Room" value={newSubject.room} onChange={e => setNewSubject({ ...newSubject, room: e.target.value })} />
        <button className="btn btn-success" type="submit">Add Subject</button>
      </form>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Grade Level</th>
              <th>Strand</th>
              <th>Teacher</th>
              <th>Schedule</th>
              <th>Room</th>
              <th style={{ width: 120 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {subjects.map(subject => (
              <tr key={subject.id}>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.code} onChange={e => setEditSubject({ ...editSubject, code: e.target.value })} />) : subject.code}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.name} onChange={e => setEditSubject({ ...editSubject, name: e.target.value })} />) : subject.name}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.gradeLevel} onChange={e => setEditSubject({ ...editSubject, gradeLevel: e.target.value })} />) : subject.gradeLevel}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.strand} onChange={e => setEditSubject({ ...editSubject, strand: e.target.value })} />) : subject.strand}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.teacher} onChange={e => setEditSubject({ ...editSubject, teacher: e.target.value })} />) : subject.teacher}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.schedule} onChange={e => setEditSubject({ ...editSubject, schedule: e.target.value })} />) : subject.schedule}</td>
                <td>{editId === subject.id ? (<input className="form-control" value={editSubject.room} onChange={e => setEditSubject({ ...editSubject, room: e.target.value })} />) : subject.room}</td>
                <td>
                  {editId === subject.id ? (
                    <>
                      <button className="btn btn-primary btn-sm me-2" onClick={() => { handleEditSubject(subject.id, editSubject); setEditId(null); }}>Save</button>
                      <button className="btn btn-secondary btn-sm" onClick={() => setEditId(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="btn btn-warning btn-sm me-2" onClick={() => { setEditId(subject.id); setEditSubject({ ...subject }); }}>Edit</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteSubject(subject.id)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}